'use strict';

const $ = require('jquery');

$('body').append($('<textarea id="clipboard-buffer" style="position: absolute; top: -1024px;"></textarea>'));
const buf = document.getElementById('clipboard-buffer');

module.exports = {
    /**
     * clipboard に params.text をセットできるよう、不可視領域にある clipboard-buffer に値をセットして、選択状態にします。
     * clipboard へのコピーに成功すると params.onSet callback が呼ばれます。
     *
     * 呼び出し元で clipboard へのコピーイベントが発火していない場合には、 execCopy() を別途呼び出してください。
     *
     * @param params
     */
    setText: function(params) {
        buf.value = params.text;
        buf.select();
        buf.onbeforecopy = function() {
            if(params.onSet) {
                params.onSet();
            }
            setTimeout(function() {
                buf.blur();
            }, 10);
        }
    },

    /**
     * 現在の document 内部の選択されている箇所をクリップボードにコピーします。
     *
     */
    execCopy: function() {
        document.execCommand("Copy");
    },

    /**
     * clipboard の内容を取得します。
     *
     * 内容は params.onGet callback の引数として渡ってきます。
     *
     * @param params
     */
    getText: function(params) {
        buf.focus();
        buf.value = '';
        buf.onpaste = function() {
            setTimeout(function() {
                params.onGet(buf.value);
                buf.blur();
            }, 10);
        };
    }
};



// WEBPACK FOOTER //
// ./common/util/clipboard.js